function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKHASH opcode — verify witness preimage hashes to script hash.
 */

module.exports = {
  name: 'CHECKHASH',
  description: 'Verify that a preimage hashes to a given Blake3 hash.',
  exampleScript: {
    op: 'CHECKHASH',
    hash: '<hash>',
    witness: {
      input: '<secret>'
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.hash !== 'function') {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(witness, 'input')) {
      return false;
    }
    var input = witness.input;
    if (input === undefined || input === null) {
      return false;
    }
    if (typeof input === 'string' && input.length === 0) {
      return false;
    }
    var hash = node.hash;
    if (typeof hash !== 'string' || hash.length === 0) {
      return false;
    }
    var computed = context.app.crypto.hash(input);
    if (typeof computed !== 'string' || computed.length === 0) {
      return false;
    }
    return computed === hash;
  }
};